














































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fetchCambioServicio } from './fetchCambioServicio';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Snotify } from '@/snotify/Snotify';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import config from '@/config/index';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class CambioActivoCliente extends Vue {
  constructor() {
    super();
  }

  @Prop({ default: null }) accion_modal: any;
  @Prop({ default: null }) cliente_id_saliente: any;
  @Prop({ default: null }) flota_saliente: any;
  @Prop({ default: null }) patente_saliente: any;
  @Prop({ default: null }) titulo: any;
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify;
  dictionaryFormErrors: any = {};
  lista_clientename: any = null;
  lista_flotaname: any[] = [];
  lista_patentes: any[] = [];
  naranja: boolean = false;
  formFields: FormFieldDefMap = {
    patente_vehiculo_new: {
      label: 'Patente',
      id: '',
      value: '',
    },
    cod_flota_new: {
      label: 'Flota',
      id: '',
      value: '',
    },
    cliente_id_new: {
      label: 'Cliente',
      id: '',
      value: '',
    },
  };

  handleInput(): void {
    this.getValidationErrorClass('patente');
    this.convertirAMayusculas();
  }

  convertirAMayusculas(): void {
    const value = this.formFields.patente_vehiculo_new.value;

    if (typeof value === 'string') {
      this.formFields.patente_vehiculo_new.value = value.toUpperCase();
    }
  }

  async get_tipoeq() {
    this.loadingService.showLoading();
    return fetchCambioServicio({}, 'conectaCambioServicio/getClientes')
      .then((data: any) => {
        this.loadingService.hideLoading();
        let res = data.data.data;
        this.lista_clientename = res;
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  } //end get_tipoeq

  async get_flota() {
    this.loadingService.showLoading();

    return fetchCambioServicio(
      { id_cliente: this.formFields.cliente_id_new.value },
      'conectaCambioServicio/getFlotas'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          let res = data.data.data.LISTA;
          this.lista_patentes = data.data.data2.LISTA;
          this.lista_flotaname = res;
        } else {
          this.loadingService.hideLoading();
          this.lista_patentes = [];
          this.lista_flotaname = [];
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        this.lista_patentes = [];
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  } //end buscar_serie_numero
  async get_pantente() {
    this.loadingService.showLoading();

    return fetchCambioServicio(
      {
        id_cliente: this.formFields.cliente_id_new.value,
        patente: this.formFields.cod_flota_new.value,
      },
      'conectaCambioServicio/getPatente'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          this.lista_patentes = data.data.data2.LISTA;
        } else {
          this.loadingService.hideLoading();
          this.lista_patentes = [];
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        this.lista_patentes = [];
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  getValidationErrorClass(fieldName: string) {
    const error = this.errors.first(fieldName);
    const isRegexError =
      error && error.includes('(AA0000)') && error.includes('(AAAA00)');

    this.naranja = isRegexError;

    const elements = document.querySelectorAll(
      '#modal-mantenedor-container > div.cardnew > div > div > div > form > div > div:nth-child(5) > div > div.layout.wrap > div:nth-child(3)'
    );
    elements.forEach(element => {
      const messageElement = element.querySelector('.v-messages__message');
      if (messageElement) {
        if (isRegexError) {
          messageElement.classList.add('orange-error--text');
        } else {
          messageElement.classList.remove('orange-error--text');
        }
      }
    });
  }

  mounted() {
    if (this.accion_modal == 'EDITAR') {
      this.formFields.cliente_id_new.value = this.cliente_id_saliente;
      this.formFields.cod_flota_new.value = this.flota_saliente;
      this.formFields.patente_vehiculo_new.value = this.patente_saliente;
    } else {
      this.get_tipoeq();
    }
    this.dictionaryFormErrors = {
      custom: {
        patente: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          regex: () =>
            'Patente con formato diferente al ya preestablecido (AA0000) o (AAAA00)',
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }

  respuesta: any;
  @Watch('formFields')
  async onModelTipoCambioChanged(val: any, oldVal: any) {
    this.$emit('input', this.formFields);
  }
} //end class
